import React, { useRef, useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import CommonToast from "../../../../Common_Components/CommonToast";
import {
  AddLookToAvatar,
  DeleteLookToAvatar,
  FetchLookToAvatar,
  UploadPersonalPhotoForHeygen,
} from "../../../../../contexts/WorkspaceUtils";
import { FaArrowLeft, FaPen, FaRedo, FaCheck, FaTimes } from "react-icons/fa";
import {
  Box,
  CardContent,
  CardMedia,
  Checkbox,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CustomAvatar from "./CustomAvatar/CustomAvatar";
import goodpic1 from "../../../../../assets/Heygen/goodpicexampleone.png";
import goodpic2 from "../../../../../assets/Heygen/goodpicexamplesec.png";
import goodpic3 from "../../../../../assets/Heygen/goodpicexamplerhi.png";
import goodpic4 from "../../../../../assets/Heygen/goodpicexamplefour.png";
import goodpic5 from "../../../../../assets/Heygen/goodpicexamplefive.png";
import badpic1 from "../../../../../assets/Heygen/badpicexampleone.png";
import badpic2 from "../../../../../assets/Heygen/badpicexamplesec.png";
import badpic3 from "../../../../../assets/Heygen/badpicexamplethir.png";
import badpic4 from "../../../../../assets/Heygen/badpicexamplefour.png";
import badpic5 from "../../../../../assets/Heygen/badpicexamplefive.png";
import {
  button_bg_color_for_New_Project,
  uploadFiles_button_default_bg_color,
  uploadFiles_button_hovered_bg_color,
} from "../../../../../constants/colors";
import { useWorkspace } from "../../../../../contexts/WorkspaceContext";
import { Card, Spinner } from "react-bootstrap";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import CommanModalForConformation from "../../../../Common_Components/CommanModalForConformation";

const AddLook = ({ open, handleClose, currentAvatar }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadLookLoader, setUploadLookLoader] = useState(false);
  const [openToast, setOpen] = useState(false);
  const [content, setContent] = useState("");
  const [iconType, setIconType] = useState("success");
  const [bgColor, setBgColor] = useState("#282D51");
  const [allLooks, setAllLooks] = useState(null);
  const [allLookFetchLoader, setAllLookFetchLoader] = useState(null);
  const [showCustomAvatar, setShowCustomAvatar] = useState(false);
  const [activeView, setActiveView] = useState("selection");
  const [hoverForDeleteButton, setHoverForDeleteButton] = useState(false);
  const [hoveredCardIndex, setHoveredCardIndex] = useState(null);
  const [moreOptionIndex, setMoreOptionIndex] = useState(null);
  const [lookToDelete, setLookToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteLookLoading, setDeleteLookLoading] = useState(false);
  const {
    setSeletedAvatarForHeygenVideo,
    setHeygenVideoPersonalAvatarImageId,
    heygenVideoPersonalAvatarImageId,
    setHeygenVideoPersonalAvatarGroupId,
  } = useWorkspace();
  const theme = localStorage.getItem("theme");

  const fileInputRef = useRef(null);

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleFileChange = (e) => {
    // Take only the first file if multiple are selected
    //   const file = e.target.files[0];
    setSelectedFiles([...selectedFiles, e.target.files[0]]);

    //   if (file) {
    //     const validTypes = ['image/jpeg', 'image/png', 'image/heic', 'image/webp'];
    //     const isValidType = validTypes.includes(file.type);
    //     const isValidSize = file.size <= 200 * 1024 * 1024; // 200MB

    //     if (isValidType && isValidSize) {
    //       setSelectedFiles([...selectedFiles, file]); // Store as array with single file
    //     }
    //   }
  };

  const fetchlooks = async () => {
    setAllLookFetchLoader(true);
    try {
      const looks = await FetchLookToAvatar(currentAvatar?.group_id);
      const AllLooks = await looks.json();
      if (AllLooks.status) {
        // console.log("AllLooks", AllLooks?.data)
        setAllLooks(AllLooks?.data?.avatars);
      } else {
        console.log("Looks", AllLooks?.message);
      }
    } catch (error) {
      console.error("AvatarLooks", error);
    }
    setAllLookFetchLoader(false);
  };

  useEffect(() => {
    fetchlooks();
  }, []);

  const handleAddLookButtonClick = () => {
    if (allLooks.length >= 5) {
      setOpen(true);
      setIconType("error");
      setContent("Maximum upload limit reached");
      return;
    }
    setShowCustomAvatar(true);
  };

  const handleCloseCustomAvatar = () => {
    setShowCustomAvatar(false);
    setActiveView("selection");
  };

  // More Options Functions
  const handleClickMoreOption = (e, look, index) => {
    e.stopPropagation();
    setMoreOptionIndex(moreOptionIndex === index ? null : index);
    setLookToDelete(look?.id);
  };

  const openDeleteModal = () => {
    setShowDeleteModal(true);
    setMoreOptionIndex(null);
  };

  const handleCancelDeleteLook = () => {
    setShowDeleteModal(false);
    setLookToDelete(null);
  };

  const handleConfirmDeleteLook = async () => {
    setDeleteLookLoading(true);
    try {
      const deleteLook = await DeleteLookToAvatar(lookToDelete);
      const response = await deleteLook.json();
      if (response.status) {
        setOpen(true);
        setContent(response.message);
        setIconType("success");
        handleCancelDeleteLook();
        fetchlooks();
      } else {
        setOpen(true);
        setContent(response.message);
        setIconType("error");
      }
    } catch (error) {
      console.error("error", error);
      setOpen(true);
      setContent(error.message);
      setIconType("error");
    } finally {
      setDeleteLookLoading(false);
    }
  };

  const HandleLookChangeClick = (e, index, look) => {
    if (look?.status !== "completed") {
      setOpen(true);
      setContent("Can't Select This Look");
      setIconType("error");
      return;
    }
    setHeygenVideoPersonalAvatarImageId(look?.id);
    setHeygenVideoPersonalAvatarGroupId(look?.group_id);
  };

  const HandleSaveButtonClick = () => {
    setOpen(true);
    setContent("Avatar Look Updated");
    setIconType("success");
    setSeletedAvatarForHeygenVideo(null);
    handleClose();
  };

  const renderPreviewView = () => (
    <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
      {/* Title with back button */}

      {/* Image grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "16px",
          marginTop: "16px",
        }}
      >
        {allLooks?.map((look, index) => (
          <>
            {/* <div
            key={look.id}
            style={{
              position: "relative",
              width: "166px",
              height: "220px",
              flexShrink: 0,
              aspectRatio: "83/110",
              borderRadius: "16px",
              background: `url(${look?.image_url}) lightgray 50% / cover no-repeat`,
              //   border: selectedImage === image.id ? '3px solid #CAC4D0' : 'none',
              cursor: "pointer",
            }}
          ></div> */}
            <Box key={look.id}>
              <Grid
                onMouseEnter={() => {
                  setHoverForDeleteButton(true);
                  setHoveredCardIndex(index);
                }}
                onMouseLeave={() => {
                  setHoverForDeleteButton(false);
                  setHoveredCardIndex(null);
                }}
                item
                sx={{
                  width: "166px",
                  height: "220px",
                  margin: 1,
                  boxSizing: "border-box",
                }}
              >
                <Box sx={{ position: "relative" }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      position: "absolute",
                      zIndex: "1000",
                      top: "10px",
                    }}
                  >
                    {look?.status !== "completed" ? (
                      <Box
                        sx={{
                          display: "flex",
                          position: "absolute",
                          border:
                            look.status !== "pending"
                              ? "1px solid rgba(221, 32, 37, 1)"
                              : "1px solid #CAC4D0",
                          backgroundColor:
                            look.status !== "pending"
                              ? "rgba(221, 32, 37, 0.20)"
                              : "rgba(202, 196, 208, 0.20)",
                          width: "74px",
                          height: "20px",
                          borderRadius: "4px",
                          color:
                            look.status !== "pending"
                              ? "rgba(221, 32, 37, 1)"
                              : "rgba(202, 196, 208, 1)",
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontStyle: "normal",
                          fontWeight: 600,
                          lineHeight: "16px",
                          letterSpacing: "0.1px",
                          top: "10px",
                          left: "10px",
                          zIndex: 20,
                          textAlign: "center",
                          justifyContent: "center",
                        }}
                      >
                        {look.status === "pending" ? "Pending" : "Rejected"}
                      </Box>
                    ) : null}

                    {hoverForDeleteButton &&
                      hoveredCardIndex === index &&
                      look?.id !== look?.group_id && (
                        <Box
                          onClick={(e) => handleClickMoreOption(e, look, index)}
                          variant="contained"
                          sx={{
                            position: "absolute",
                            zIndex: "1000",
                            top: "0px",
                            left: "135px",
                            backgroundColor: "transparent",
                            color: "black",
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "8px",
                            cursor: "pointer",
                            "&:hover": {
                              color: "#2F355F",
                            },
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M11.875 16.25C11.875 16.7473 11.6775 17.2242 11.3258 17.5758C10.9742 17.9275 10.4973 18.125 10 18.125C9.50272 18.125 9.02581 17.9275 8.67417 17.5758C8.32254 17.2242 8.125 16.7473 8.125 16.25C8.125 15.7527 8.32254 15.2758 8.67417 14.9242C9.02581 14.5725 9.50272 14.375 10 14.375C10.4973 14.375 10.9742 14.5725 11.3258 14.9242C11.6775 15.2758 11.875 15.7527 11.875 16.25ZM11.875 10C11.875 10.4973 11.6775 10.9742 11.3258 11.3258C10.9742 11.6775 10.4973 11.875 10 11.875C9.50272 11.875 9.02581 11.6775 8.67417 11.3258C8.32254 10.9742 8.125 10.4973 8.125 10C8.125 9.50272 8.32254 9.02581 8.67417 8.67417C9.02581 8.32254 9.50272 8.125 10 8.125C10.4973 8.125 10.9742 8.32254 11.3258 8.67417C11.6775 9.02581 11.875 9.50272 11.875 10ZM11.875 3.75C11.875 4.24728 11.6775 4.72419 11.3258 5.07583C10.9742 5.42746 10.4973 5.625 10 5.625C9.50272 5.625 9.02581 5.42746 8.67417 5.07583C8.32254 4.72419 8.125 4.24728 8.125 3.75C8.125 3.25272 8.32254 2.77581 8.67417 2.42417C9.02581 2.07254 9.50272 1.875 10 1.875C10.4973 1.875 10.9742 2.07254 11.3258 2.42417C11.6775 2.77581 11.875 3.25272 11.875 3.75Z"
                              fill="white"
                            />
                          </svg>
                        </Box>
                      )}
                  </Box>

                  {moreOptionIndex === index && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "30px",
                        left: "100px",
                        zIndex: 1100,
                        backgroundColor: "#2F355F",
                        borderRadius: "8px",
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                        border: "1px solid rgba(255, 255, 255, 0.10)",
                        padding: "8px 0",
                        maxWidth: "168px",
                        width: "auto",
                      }}
                    >
                      <Box
                        className="delete-option-container"
                        sx={{
                          display: "flex", // makes icon and text inline
                          alignItems: "center", // vertically centers icon and tex
                          padding: "8px 16px",
                          color: "white",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          cursor: "pointer",
                          whiteSpace: "nowrap",
                          "&:hover": {
                            backgroundColor: "rgba(255, 255, 255, 0.10)",
                          },
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          openDeleteModal();
                        }}
                      >
                        <DeleteIcon
                          sx={{
                            color: "rgba(202, 196, 208, 1)",
                            marginRight: "12px",
                            "&:hover": { color: "rgba(202, 196, 208, 1)" },
                          }}
                        />
                        Delete
                      </Box>
                    </Box>
                  )}

                  <Card
                    onClick={(e) => HandleLookChangeClick(e, index, look)}
                    sx={{
                      margin: "0px",
                      padding: "12px",
                      width: "166px",
                      height: "220px",
                      display: "flex",
                      flexDirection: "column",
                      rowGap: "8px",
                      borderRadius: "16px",
                      // backgroundColor: heygenVideoPersonalAvatarImageId === avatar.group_id && (avatar.status !== "pending" || avatar?.status !== "moderation_rejected")  ? "#2F355F" : "#1F233E",
                      // outline:  heygenVideoPersonalAvatarImageId === avatar.group_id && (avatar.status !== "pending" || avatar?.status !== "moderation_rejected") ? "1px solid rgba(255, 255, 255, 0.30)" : "1px solid rgba(255, 255, 255, 0.10)",
                      backgroundColor: "#1F233E",
                      outline: "1px solid rgba(255, 255, 255, 0.10)",
                      cursor: "pointer",
                      boxShadow: "none",
                      "&:hover": {
                        borderRadius: "16px",
                        // backgroundColor: heygenVideoPersonalAvatarImageId !== avatar.group_id && "#2F355F",
                        // outline: heygenVideoPersonalAvatarImageId !== avatar.group_id && "1px solid rgba(255, 255, 255, 0.10)"
                      },
                    }}
                    // onClick={() => {
                    //     if (avatar.status !== "pending" && avatar.status !== "moderation_rejected") {
                    //       handleAvatarSelect(avatar);
                    //     }
                    // }}
                  >
                    <CardMedia
                      sx={{
                        height: "220px",
                        width: "166px",
                        filter: look.status !== "completed" && "blur(5px)",
                      }}
                      component="img"
                      alt={"Your avatar"}
                      image={look?.image_url}
                    />
                    {look?.id === heygenVideoPersonalAvatarImageId && (
                      <div
                        style={{
                          position: "absolute",
                          top: "8px",
                          left: "8px",
                          width: "24px",
                          height: "24px",
                          borderRadius: "50%",
                          background: "#4F46E5",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          border: "none",
                        }}
                      >
                        {/* <FaCheck size={12} color="white" /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_11266_63971)">
                            <circle cx="10" cy="10" r="10" fill="#9EFFCF" />
                            <path
                              d="M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
                              fill="#23A565"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_11266_63971">
                              <rect width="20" height="20" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    )}
                    {/* <CardContent sx={{ padding: '0px', textAlign: 'center', margin: "0px", height: "14px", backgroundColor:"transparent" }}>
                      <Typography sx={{
                        color: 'white',
                        fontFamily: "Inter",
                        fontSize: '14px',
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "normal",
                        letterSpacing: "0.082px"
                      }}>
                        {look?.name ? look?.name : 'Your Avatar'}
                      </Typography>
                    </CardContent> */}
                  </Card>
                </Box>
              </Grid>
            </Box>
          </>
        ))}
        <Box
          onClick={handleAddLookButtonClick}
          sx={{
            display: "flex",
            width: "144px",
            padding: "37px 27px",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "16px",
            border: "1px solid rgba(255, 255, 255, 0.10)",
            margin: 1,
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "#2F355F",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "48px",
              height: "48px",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
              borderRadius: "80px",
              background: "#282D51",
              marginBottom: "16px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                padding: "8px",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <AddIcon
                sx={{
                  width: "24px",
                  height: "24px",
                  color: "rgba(202, 196, 208, 1)",
                }}
              />
            </Box>
          </Box>
          <Typography
            sx={{
              color: "#CAC4D0",
              textAlign: "center",
              fontFamily: "Inter",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "20px",
              letterSpacing: "0.1px",
            }}
          >
            Add New Look
          </Typography>
        </Box>
      </div>

      {/* Footer buttons */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
          marginTop: "24px",
        }}
      >
        <Button
          onClick={handleClose}
          sx={{
            mr: 1,
            backgroundColor: theme === "dark" ? "" : "",
            "&:hover": {
              color: "rgba(255, 255, 255, 0.8)",
              backgroundColor: "transparent",
            },
            color: "rgba(255, 255, 255, 1)",
            fontSize: "16px",
            fontWeight: "600",
            textTransform: "none",
            fontFamily: "Inter, sans-serif",
          }}
        >
          Close
        </Button>
        <Button
          disabled={allLooks?.length === 0}
          variant="contained"
          onClick={() => HandleSaveButtonClick()}
          sx={{
            backgroundColor:
              theme === "dark" ? button_bg_color_for_New_Project : "",
            "&:hover": {
              backgroundColor: "#FFD9AA",
            },
            "&:disabled": {
              backgroundColor: "rgba(230, 224, 233, 0.12)",
              color: "#E6E0E9",
              opacity: 0.38,
              cursor: "not-allowed",
            },
            width: "auto",
            color: "#17182C",
            fontSize: "16px",
            fontWeight: 600,
            textTransform: "none",
            fontFamily: "Inter, sans-serif",
          }}
        >
          Save
        </Button>
      </div>
      {showDeleteModal && (
        <CommanModalForConformation
          open={showDeleteModal}
          modalTitle={"Delete Look"}
          modalMessage={
            "Are you sure you want to delete this look? This action cannot be undone."
          }
          handleConfirm={handleConfirmDeleteLook}
          handleCancel={handleCancelDeleteLook}
          confirmTitle={"Yes, delete look"}
          loading={deleteLookLoading}
        />
      )}
    </div>
  );

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: "16px !important",
            maxWidth: "800px",
          },
        }}
      >
        {!showCustomAvatar ? (
          <div
            style={{
              maxWidth: "750px",
              maxHeight: "850px",
              flexShrink: 0,
              borderRadius: "16px",
              border: "1px solid rgba(255, 255, 255, 0.10)",
              background: "#1F233E",
              overflow: "hidden",
              position: "relative",
            }}
          >
            {/* Modal Header */}
            <div
              style={{
                display: "flex",
                width: "750px",
                padding: "20px",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
              }}
            >
              <div
                style={{
                  color: "#FFF",
                  textAlign: "center",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: "600",
                  lineHeight: "20px",
                }}
              >
                Add Look to your AI avatar
              </div>
              <button
                onClick={handleClose}
                style={{
                  background: "transparent",
                  border: "none",
                  color: "white",
                  cursor: "pointer",
                  fontSize: "20px",
                }}
              >
                <CloseIcon />
              </button>
            </div>

            {/* Modal Body */}
            <div
              style={{
                padding: "20px",
                height: "calc(100% - 61px)",
                overflowY: "auto",
              }}
            >
              {allLookFetchLoader ? (
                <CircularProgress
                  color="secondary"
                  size="30px"
                  sx={{ color: "#ffffff", display: "flex", margin: "0 auto" }}
                />
              ) : (
                renderPreviewView()
              )}
            </div>
          </div>
        ) : (
          <div>
            <AddLookModal
              currentAvatar={currentAvatar}
              handleClose={handleClose}
            />
          </div>
        )}
      </Dialog>
      <CommonToast
        open={openToast}
        onClose={onClose}
        content={content}
        iconType={iconType}
        bgColor={bgColor}
      />
    </>
  );
};

const AddLookModal = ({ currentAvatar, handleClose }) => {
  const [currentStep, setCurrentStep] = useState("upload");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [imageuploadFile, setImageUploadFile] = useState(null);
  const fileInputRef = useRef(null);
  const [openToast, setOpenToast] = useState(false);
  const [content, setContent] = useState(null);
  const [iconType, setIconType] = useState(null);
  const [bgColor, setBgColor] = useState("#282D51");
  const [uploadImageLoader, setUploadImageLoader] = useState(false);
  const [avatarCreationLoader, setAvatarCreationLoader] = useState(false);
  const [selectedAvatar, setSelectedAvatar] = useState(0);
  const [formData, setFormData] = useState({
    name: "",
    termsAccepted: false,
  });
  const { uploadedImageData, setUploadedImageData } = useWorkspace();

  const customTextFieldStyles = (isInvalid) => {
    return {
      "& .MuiInputLabel-root": {
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
        letterSpacing: "0.5px",
        color: "rgba(255, 255, 255, 0.80)",
        "&.Mui-focused": {
          color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80)",
        },
      },
      "& .MuiInputBase-input": {
        color: "#FFFFFF",
      },
      "& #outlined-basic-label": {
        color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80)",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: isInvalid ? "#F2B8B5" : "rgba(255, 255, 255, 0.80)",
        },
        "&:hover fieldset": {
          borderColor: isInvalid ? "#F2B8B5" : "rgba(255, 255, 255, 0.80)",
        },
        "&.Mui-focused fieldset": {
          borderColor: isInvalid
            ? "#F2B8B5 !important"
            : "rgba(255, 255, 255, 0.80) ",
        },
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
        color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80) ",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: isInvalid
          ? "#F2B8B5 !important"
          : "rgba(255, 255, 255, 0.80) ",
      },
    };
  };

  const goodImageExampleArray = [
    { img: goodpic1, name: "image1" },
    { img: goodpic2, name: "image2" },
    { img: goodpic3, name: "image3" },
    { img: goodpic4, name: "image4" },
    { img: goodpic5, name: "image5" },
  ];

  const badImageExampleArray = [
    { img: badpic1, name: "image1" },
    { img: badpic2, name: "image2" },
    { img: badpic3, name: "image3" },
    { img: badpic4, name: "image4" },
    { img: badpic5, name: "image5" },
  ];

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    // Take only the first file if multiple are selected
    const file = e.target.files[0];

    if (file) {
      const validTypes = [
        "image/jpeg",
        "image/png",
        "image/heic",
        "image/webp",
      ];
      const isValidType = validTypes.includes(file.type);
      const isValidSize = file.size <= 200 * 1024 * 1024; // 200MB

      if (isValidType && isValidSize) {
        setSelectedFiles([file]); // Store as array with single file
        setImageUploadFile(file);
      }
    }
  };

  const uploadFile = async () => {
    const formDataForUpload = new FormData();
    formDataForUpload.append("file", imageuploadFile);
    try {
      setUploadImageLoader(true);
      const response = await UploadPersonalPhotoForHeygen(formDataForUpload);
      const res = await response.json();
      console.log("response", res);

      if (res.status) {
        console.log("res", res);
        setOpenToast(true);
        setContent(res?.message);
        setIconType("success");
        setUploadedImageData(res?.data?.data);
        setCurrentStep("details");
      } else {
        setOpenToast(true);
        setContent(res?.message);
        setIconType("error");
      }
    } catch (error) {
      console.error("error", error);
      setOpenToast(true);
      setContent(error.message);
      setIconType("error");
    }
    setUploadImageLoader(false);
  };

  const UploadLookInAvatar = async () => {
    if (formData?.name === "") {
      setOpenToast(true);
      setContent("Please Enter Avatar Name");
      setIconType("error");
      return;
    }
    const data = {
      image_keys: [uploadedImageData?.image_key],
      name: formData?.name,
      group_id: currentAvatar?.group_id,
    };
    try {
      setAvatarCreationLoader(true);
      const uploadLook = await AddLookToAvatar(data);
      const response = await uploadLook.json();
      if (response.status) {
        setAvatarCreationLoader(false);
        setCurrentStep("complete");
      } else {
        setOpenToast(true);
        setContent(response?.message);
        setIconType("error");
      }
    } catch (error) {
      setOpenToast(true);
      setContent(error?.message);
      setIconType("error");
    }
  };

  const handleProceed = async () => {
    if (currentStep === "upload") {
      await uploadFile();
    } else if (currentStep === "details") {
      await UploadLookInAvatar();
    }
  };

  const onClose = () => {
    setOpenToast(false);
  };

  const HandleCloseButtonClick = () => {
    handleClose();
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleDoneButtonClick = () => {
    handleClose();
    setUploadedImageData(null);
  };

  const renderUploadStep = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        height: "100%",
        width: "auto",
      }}
    >
      <div>
        <div
          style={{
            color: "#FFF",
            fontFamily: "Inter",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "20px",
            marginBottom: "8px",
          }}
        >
          Upload photos for your avatar looks
        </div>
        <div
          style={{
            color: "rgba(255, 255, 255, 0.80)",
            fontFamily: "Inter",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "normal",
          }}
        >
          Upload photos to create multiple looks for your avatar
        </div>
      </div>

      <div
        style={{
          display: "flex",
          width: "710px",
          padding: "20px",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "24px",
          borderRadius: "12px",
          background: "#1A1E35",
        }}
      >
        <div
          style={{
            color: "#FFF",
            textAlign: "center",
            fontFamily: "Inter",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "normal",
          }}
        >
          Select files or drop to upload
        </div>
        <div
          style={{
            color: "rgba(255, 255, 255, 0.60)",
            textAlign: "center",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "normal",
          }}
        >
          JPEG, PNG, HEIC, WEBP, upto 200mb
        </div>
        <button
          onClick={handleUploadClick}
          style={{
            display: "flex",
            width: "220px",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            padding: "12px 24px",
            borderRadius: "8px",
            background: "white",
            border: "none",
            color: "black",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "500",
            gap: "8px",
          }}
        >
          <CloudUploadOutlinedIcon />
          Browse files
        </button>
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: "none" }}
          accept="image/jpeg, image/png, image/heic, image/webp"
        />
      </div>

      {selectedFiles?.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <div
            style={{
              color: "#FFF",
              fontFamily: "Inter",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            Selected files ({selectedFiles?.length})
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
            {selectedFiles?.map((file, index) => (
              <div
                key={index}
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "8px",
                  background: `url(${URL.createObjectURL(
                    file
                  )}) center/cover no-repeat`,
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                }}
              />
            ))}
          </div>
        </div>
      )}

      <div
        style={{
          width: "710px",
          height: "537px",
          flexShrink: "0",
          borderRadius: "16px",
          border: "1px solid rgba(255, 255, 255, 0.10)",
          background: "#1F233E",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          gap: "24px",
        }}
      >
        <div
          style={{
            color: "#FFF",
            fontFamily: "Inter",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "20px",
            letterSpacing: "0.1px",
          }}
        >
          Photo Requirements
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <FaCheck color="#4CAF50" />
            <div
              style={{
                color: "#FFF",
                fontFamily: "Inter",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: "500",
                lineHeight: "20px",
                letterSpacing: "0.1px",
              }}
            >
              Good photos
            </div>
          </div>
          <div
            style={{
              color: "rgba(255, 255, 255, 0.80)",
              fontFamily: "Inter",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: "400",
              lineHeight: "normal",
              letterSpacing: "0.1px",
            }}
          >
            Recent photos of yourself (just you), showing a mix of close-ups and
            full-body shots, with different angles, expressions (smiling,
            neutral, serious), and a variety of outfits. Make sure they are
            High-resolution and reflect your current appearance.
          </div>
          <div
            style={{
              display: "flex",
              width: "640px",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {goodImageExampleArray?.map((obj, i) => (
              <div
                key={`good-${i}`}
                style={{
                  width: "93.838px",
                  height: "124px",
                  flexShrink: "0",
                  aspectRatio: "93.84/124.00",
                  borderRadius: "8px",
                  background: "#2D3250",
                }}
              >
                <img
                  width={"93.838px"}
                  height={"124px"}
                  src={obj?.img}
                  alt={obj?.name}
                />
              </div>
            ))}
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <FaTimes color="#F44336" />
            <div
              style={{
                color: "#FFF",
                fontFamily: "Inter",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: "500",
                lineHeight: "20px",
                letterSpacing: "0.1px",
              }}
            >
              Bad photos
            </div>
          </div>
          <div
            style={{
              color: "rgba(255, 255, 255, 0.80)",
              fontFamily: "Inter",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: "400",
              lineHeight: "normal",
              letterSpacing: "0.1px",
            }}
          >
            No group photos, hats, sunglasses, pets, heavy filters,
            low-resolution images, or screenshots. Avoid photos that are too
            old, overly edited, or don't represent how you currently look.
          </div>
          <div
            style={{
              display: "flex",
              width: "640px",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {badImageExampleArray?.map((obj, i) => (
              <div
                key={`bad-${i}`}
                style={{
                  width: "93.838px",
                  height: "124px",
                  flexShrink: "0",
                  aspectRatio: "93.84/124.00",
                  borderRadius: "8px",
                  background: "#2D3250",
                }}
              >
                <img
                  width={"93.838px"}
                  height={"124px"}
                  src={obj?.img}
                  alt={obj?.name}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  const renderDetailsStep = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        height: "100%",
      }}
    >
      <div
        style={{
          color: "#FFF",
          fontFamily: "Inter",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: "600",
          lineHeight: "20px",
        }}
      >
        Your avatar looks are ready!
      </div>
      <div
        style={{
          color: "rgba(255, 255, 255, 0.80)",
          fontFamily: "Inter",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: "400",
          lineHeight: "normal",
          marginTop: "-12px",
        }}
      >
        Name your avatar look to bring it to life
      </div>

      {selectedAvatar !== null && (
        <div
          style={{
            display: "flex",
            alignSelf: "center",
            width: "93.838px",
            height: "124px",
            flexShrink: "0",
            aspectRatio: "93.84/124.00",
            borderRadius: "8px",
            background: `url(${URL.createObjectURL(
              selectedFiles[selectedAvatar]
            )}) center/cover no-repeat`,
          }}
        />
      )}

      <Box
        sx={{
          display: "flex",
          gap: 2, // MUI spacing scale – equals 16px by default
          width: "100%",
          mb: 3,
          justifyContent: "center",
        }}
      >
        <TextField
          type="text"
          label="Name*"
          placeholder="What do you want to name your avatar look?"
          value={formData?.name || ""}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              name: e.target.value,
            }))
          }
          variant="outlined"
          id="outlined-basic"
          sx={[
            customTextFieldStyles(false),
            {
              flex: 1, // takes up equal share
              maxHeight: 56,
              fontSize: 14,
              maxWidth: "348px",
            },
          ]}
        />
      </Box>

      <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
        <Checkbox
          type="checkbox"
          name="termsAccepted"
          checked={formData.termsAccepted}
          onChange={handleInputChange}
          style={{
            display: "flex",
            width: "20px",
            height: "20px",
            justifyContent: "center",
            alignItems: "center",
            flexShrink: "0",
          }}
          sx={{ color: "#CAC4D0", "&.Mui-checked": { color: "#CAC4D0" } }}
        />
        <div
          style={{
            color: "rgba(255, 255, 255, 0.80)",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "normal",
            letterSpacing: "0.1px",
          }}
        >
          By creating an avatar, I confirm that I am over 18 years of age (or
          the legal age in my country) and that the photos used belong to me or
          I have obtained explicit permission from the individual represented. I
          understand that I am solely responsible for the content I upload and
          that the use of these images must comply with all applicable laws and
          regulations. Additionally, I agree not to upload any photos that
          infringe on others' rights or that I do not have permission to use. By
          proceeding, I accept the Terms of Service and Privacy Policy.
        </div>
      </div>
    </div>
  );

  const renderCompleteStep = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "24px",
        height: "auto",
        padding: "40px 20px",
      }}
    >
      <div
        style={{
          color: "#FFF",
          textAlign: "center",
          fontFamily: "Inter",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: "600",
          lineHeight: "20px",
        }}
      >
        New looks have been added to your avatar
      </div>
      {/* <div style={{
        color: 'rgba(255, 255, 255, 0.80)',
        textAlign: 'center',
        fontFamily: 'Inter',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: 'normal'
      }}>
        You can now select this avatar for generating videos
      </div> */}

      {selectedAvatar !== null && (
        <div
          style={{
            width: "166.486px",
            height: "220px",
            flexShrink: "0",
            aspectRatio: "166.49/220.00",
            borderRadius: "16px",
            background: `url(${URL.createObjectURL(
              selectedFiles[selectedAvatar]
            )}) center/cover no-repeat`,
          }}
        />
      )}

      <button
        onClick={handleDoneButtonClick}
        style={{
          display: "flex",
          width: "238px",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "8px",
          background: "#F6BE6B",
          padding: "12px 24px",
          border: "none",
          color: "#17182C",
          cursor: "pointer",
          fontSize: "14px",
          fontWeight: "500",
        }}
      >
        Done
      </button>
    </div>
  );

  return (
    <div
      style={{
        maxWidth: "auto",
        height: "auto",
        maxHeight: "100%",
        flexShrink: 0,
        borderRadius: "16px",
        border: "1px solid rgba(255, 255, 255, 0.10)",
        background: "#1F233E",
        overflow: "hidden",
        position: "relative",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          padding: "20px",
          justifyContent:
            currentStep === "complete" ? "flex-end" : "space-between",
          alignItems: "center",
          borderBottom:
            currentStep === "complete"
              ? "none"
              : "1px solid rgba(255, 255, 255, 0.10)",
          flexShrink: 0,
        }}
      >
        <div
          style={{
            display: currentStep === "complete" ? "none" : "flex",
            color: "#FFF",
            textAlign: "center",
            fontFamily: "Inter",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "20px",
          }}
        >
          Add looks to your avatar
        </div>

        <button
          onClick={handleDoneButtonClick}
          style={{
            background: "transparent",
            border: "none",
            color: "white",
            cursor: "pointer",
            fontSize: "20px",
          }}
        >
          <CloseIcon />
        </button>
      </div>
      {/* Scrollable Content Area */}
      <div
        style={{
          padding: currentStep === "complete" ? "0" : "20px",
          overflowY: "auto",
          flex: 1,
        }}
      >
        {currentStep === "upload" && renderUploadStep()}
        {currentStep === "details" && renderDetailsStep()}
        {currentStep === "complete" && renderCompleteStep()}
      </div>
      {/* Static Footer (hidden in complete step) */}
      {currentStep !== "complete" && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "16px",
            padding: "20px",
            borderTop: "1px solid rgba(255, 255, 255, 0.10)",
            flexShrink: 0,
          }}
        >
          {currentStep === "upload" && (
            <>
              <button
                onClick={HandleCloseButtonClick}
                style={{
                  padding: "12px 24px",
                  borderRadius: "8px",
                  background: "transparent",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  color: "white",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Close
              </button>
              <button
                onClick={handleProceed}
                disabled={selectedFiles.length === 0 || uploadImageLoader}
                style={{
                  padding: "12px 24px",
                  borderRadius: "8px",
                  background:
                    selectedFiles.length > 0
                      ? button_bg_color_for_New_Project
                      : "rgba(230, 224, 233, 0.12)",
                  border: "none",
                  color: selectedFiles.length > 0 ? "#17182C" : "#E6E0E9",
                  opacity: selectedFiles.length > 0 ? 1 : 0.38,
                  cursor: selectedFiles.length > 0 ? "pointer" : "not-allowed",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                {uploadImageLoader ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  "Upload"
                )}
              </button>
            </>
          )}
          {currentStep === "details" && (
            <>
              <button
                onClick={() => setCurrentStep("upload")}
                style={{
                  padding: "12px 24px",
                  borderRadius: "8px",
                  background: "transparent",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  color: "white",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Back
              </button>
              <button
                onClick={handleProceed}
                disabled={!formData.termsAccepted}
                style={{
                  padding: "12px 24px",
                  borderRadius: "8px",
                  background: formData.termsAccepted
                    ? button_bg_color_for_New_Project
                    : "rgba(230, 224, 233, 0.12)",
                  border: "none",
                  color: formData.termsAccepted ? "#17182C" : "#E6E0E9",
                  cursor: formData.termsAccepted ? "pointer" : "not-allowed",
                  opacity: formData.termsAccepted ? 1 : 0.38,
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                {avatarCreationLoader ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  "Continue"
                )}
              </button>
            </>
          )}
        </div>
      )}
      <CommonToast
        open={openToast}
        onClose={onClose}
        content={content}
        iconType={iconType}
        bgColor={bgColor}
      />
    </div>
  );
};

export default AddLook;
export { AddLookModal };
